import { render, staticRenderFns } from "./mailbox-content.vue?vue&type=template&id=aeac55f8&scoped=true&"
import script from "./mailbox-content.vue?vue&type=script&lang=js&"
export * from "./mailbox-content.vue?vue&type=script&lang=js&"
import style0 from "./mailbox-content.vue?vue&type=style&index=0&id=aeac55f8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aeac55f8",
  null
  
)

export default component.exports